import { useEffect, useLayoutEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import RegulationsContent from '@/components/Regulations/RegulationsContent';
import arrowRightIcon from '@/assets/icons/arrowRight.svg';
import styles from './RegulationsPage.module.scss';

export const REGULATIONS_PAGE_PATH = '/regulations';

/**
 * נהלי העמותה במלואם - תנאי הצטרפות, נהלי תרומה ותמיכה, סיווגים ותקורות.
 *
 * העמוד נולד עבור חלונית אישור הנהלים בכניסה לאתר (HAT-1256): החלונית מציגה את
 * ארבעת הכללים בתמצית, ומי שרוצה לקרוא את הנוסח המלא לפני שהוא חותם פותח מכאן.
 * התוכן עצמו הוא אותו רכיב שמופיע בשלב "מידע נוסף ותנאי שימוש" בטופס פתיחת קרן,
 * כדי שלא ייווצרו שני נוסחים.
 *
 * נתיב ציבורי בכוונה, משתי סיבות: הנהלים ממילא גלויים בטופס פתיחת הקרן הפתוח
 * לכל, והחלונית החוסמת חייבת לאפשר לקרוא אותם - עמוד שדורש סשן פתוח היה נחסם
 * על ידי אותה חלונית שממנה הגיעו אליו.
 */
const RegulationsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  /*
   * העמוד עומד מחוץ למעטפת - בלי תפריט ובלי כותרת - ולכן מי שהגיע אליו נשאר בלי
   * דרך חזרה (דרוק, 4.10).
   *
   * location.key הוא 'default' רק כשהעמוד הוא הראשון בלשונית: חלונית אישור הנהלים
   * פותחת אותו בלשונית חדשה, והאתר עצמו פתוח בלשונית שמאחוריה. שם הכפתור סוגר את
   * הלשונית ולא פותח את האתר פעם שנייה (חיה, 4.10). דפדפן שלא מרשה לסגור לשונית
   * מהדף משאיר אותה פתוחה, ואז הכפתור מוביל לדף הבית - עדיף על כפתור שלא עושה כלום.
   */
  const cameFromInsideTheSite = location.key !== 'default';

  /*
   * מעבר בין מסכים באתר משאיר את הגלילה במקומה, ולכן התקנון נפתח בגובה שבו עמד המסך
   * הקודם - באמצע, בלי הכפתור (חיה, 4.10). פותחים בראש העמוד לפני הציור, וזוכרים
   * מאיפה באו כדי ש«חזרה» תחזיר לאותה נקודה במסך הקודם.
   */
  const returnScrollY = useRef(0);
  useLayoutEffect(() => {
    returnScrollY.current = window.scrollY;
    window.scrollTo(0, 0);
  }, []);

  const goBack = () => {
    if (cameFromInsideTheSite) {
      const y = returnScrollY.current;
      navigate(-1);
      // After the previous screen has rendered in place of this one.
      window.setTimeout(() => window.requestAnimationFrame(() => window.scrollTo(0, y)), 0);
      return;
    }
    window.close();
    window.setTimeout(() => {
      if (!window.closed) navigate('/');
    }, 300);
  };

  useEffect(() => {
    document.title = 'נהלי העמותה | מרכז הצדקה';
  }, []);

  return (
    <main className={styles.page}>
      <button type="button" className={styles.backButton} onClick={goBack}>
        <img src={arrowRightIcon} alt="" aria-hidden="true" />
        {cameFromInsideTheSite ? 'חזרה' : 'סגירה'}
      </button>
      <h1 className="heading-h2-bold">נהלי העמותה וההנחיות</h1>
      <p className={styles.intro}>
        ריכזנו כאן את כל הנהלים וההנחיות החלים על פעילות הקרנות בעמותה – תנאי ההצטרפות, נהלי התרומה והתמיכה, הסיווגים והתקורות. הנהלים מתעדכנים מעת לעת, ובכל
        מקרה של סתירה בין האמור כאן לבין נהלי העמותה – יגבר האמור בנהלי העמותה.
      </p>

      <div className={styles.sections}>
        <RegulationsContent />
      </div>
    </main>
  );
};

export default RegulationsPage;
